import { Card, CardContent, Divider, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { GangMemberHeader } from './GangMemberHeader';

interface GangMemberConfigCardProps {
  fullName: string;
  email: string;
  role: 'leader' | 'member';
  description?: string;
  children: ReactNode;
}

export const GangMemberConfigCard = ({
  fullName,
  email,
  role,
  description,
  children,
}: GangMemberConfigCardProps) => {
  return (
    <Card
      sx={{ mb: 2 }}
      data-testid={`member-config-card-${fullName.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <CardContent>
        <GangMemberHeader fullName={fullName} email={email} role={role} />
        {description ? (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {description}
          </Typography>
        ) : null}
        <Divider sx={{ mb: 2 }} />
        {children}
      </CardContent>
    </Card>
  );
};
